import api from '@/apis/BaseApi';
import { OnboardingModel } from '@/apis/models/OnboardingModel';

export default class QuizApi {
  static async onboarding(body:any): Promise<OnboardingModel> {
    const result = await api.post('user/onboarding', body);
    return new OnboardingModel(result.data);
  }
}
